const keyDownEvent = (fn: (event: KeyboardEvent) => void): (() => void) => {
  document.body.addEventListener("keydown", fn);

  return () => {
    document.body.removeEventListener("keydown", fn);
  };
};

export default keyDownEvent;
